import { updateAccountUI } from './account.js';
import { CLOUD, cloudLoadLS, cloudOn, cloudPersistLS, friendlyErr, loggedIn, sbUrl } from './api.js';
import { mfaRequired } from './auth.js';
import { initLock } from './lock.js';
import { markFreshLogin, maybeSecureSheet, reportDevice } from './devices.js';
import { maybeShowAuth, openAuth } from './authui.js';
import { cloudSyncStart, setStatus } from './sync.js';
import { handleCheckoutReturn, maybeTrialEnded } from './plan.js';
import { runDeepLink } from '../notify/deeplink.js';
import { syncPush } from '../notify/push.js';
import { maybeWelcome } from '../welcome.js';
import { S } from '../state.js';
import { afterTeamLoad, joinedToast, pendingJoin, restoreTeamCache, runJoin } from '../team/team.js';
import { t } from '../i18n/index.js';
import { toast } from '../ui.js';

export async function cloudHandleRedirect(){
  if(!location.hash||location.hash.length<12)return;
  const h=new URLSearchParams(location.hash.slice(1));
  const errD=h.get('error_description');
  const at=h.get('access_token');
  if(!at&&!errD)return;
  try{history.replaceState(null,'',location.pathname+location.search)}catch(e){}
  if(location.hash){try{location.hash=''}catch(e){}}
  if(errD){toast(friendlyErr(errD));return}
  if(!cloudOn())return;
  const rt=h.get('refresh_token')||'',ei=+(h.get('expires_in')||3600);
  const isRecovery=h.get('type')==='recovery';
  try{
    const r=await fetch(sbUrl('/auth/v1/user'),{headers:{apikey:CLOUD.cfg.key,Authorization:'Bearer '+at}});
    const u=await r.json();
    const md=u.user_metadata||{};
    CLOUD.auth={at,rt,exp:Date.now()+((ei-90)*1000),email:u.email||'',uid:u.id||'',name:md.full_name||md.name||'',pic:md.avatar_url||md.picture||''};
    CLOUD.user=u;cloudPersistLS();localStorage.removeItem('plume.mode');updateAccountUI();markFreshLogin();
    if(isRecovery){openAuth('newpw');return 'recovery'}
    toast(t('cloud.in',{e:u.email||''}));
  }catch(e){}
}
/* the start screen goes away once the first meaningful screen is ready */
export function bootDone(){if(!document.body.classList.contains('booting'))return;document.body.classList.remove('booting');import('../ui.js').then(m=>m.render())}
setTimeout(bootDone,6000); // never stay hidden
export function cloudBoot(){
  cloudLoadLS();
  initLock();
  restoreTeamCache();
  updateAccountUI();
  cloudHandleRedirect().then(async r=>{
    setStatus(loggedIn()?'saving':'off');
    updateAccountUI();
    if(r==='recovery')return;
    if(loggedIn()){
      const hasData=S.students.length||S.sessions.length||S.recs.length||S.invoices.length;
      if(hasData&&!pendingJoin())bootDone();                       // returning user: show their data right away
      if(await mfaRequired()){openAuth('mfa');bootDone();}
      else{if(pendingJoin()&&await runJoin())return;await cloudSyncStart();maybeWelcome();bootDone();joinedToast();reportDevice();maybeSecureSheet();afterTeamLoad();handleCheckoutReturn();syncPush();runDeepLink();maybeTrialEnded();setTimeout(()=>import('./parents.js').then(m=>m.syncParents()).catch(()=>{}),3000)}
    }else{await maybeShowAuth();bootDone();if(!cloudOn())runDeepLink()}
  });
}

/* ================= theme ================= */
